import React from 'react';

export default function EmbeddedVideo({ videoId, title = 'Видеоинструкция', onClose }) {
  if (!videoId) return null;

  const isYouTube = videoId.startsWith('http') === false; // YouTube ID не содержит https

  const videoSrc = isYouTube
    ? `https://www.youtube.com/embed/${videoId}`
    : videoId; // если это ссылка — используем её напрямую

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={headerStyle}>
          <h2 style={titleStyle}>{title}</h2>
          <button style={closeButtonStyle} onClick={onClose}>×</button>
        </div>
        <div style={videoWrapperStyle}>
          {isYouTube ? (
            <iframe
              width="100%"
              height="315"
              src={videoSrc}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <video
              width="100%"
              height="315"
              controls
              autoPlay
            >
              <source src={videoSrc} type="video/mp4" />
              Ваш браузер не поддерживает видео.
            </video>
          )}
        </div>
      </div>
    </div>
  );
}


// --- Стили:
const overlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1015
};

const modalStyle = {
  background: 'white',
  borderRadius: '12px',
  width: '90%',
  maxWidth: '800px',
  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3)',
  overflow: 'hidden'
};

const headerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '20px',
  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  color: 'white',
  borderRadius: '12px 12px 0 0'
};

const titleStyle = {
  margin: 0,
  fontSize: '22px'
};

const closeButtonStyle = {
  background: 'none',
  border: 'none',
  fontSize: '24px',
  color: 'white',
  cursor: 'pointer',
  width: '30px',
  height: '30px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'background-color 0.2s'
};

const videoWrapperStyle = {
  padding: '0',
  aspectRatio: '16/9'
};
